// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bef_a bhv_b bhv_tu bhv_qz bhv_ra bhv_uo","PanelFooter--link":"bef_b"};